import React, { Component } from 'react';
import { Banner, Page, Layout, Card, FormLayout, TextField, SettingToggle, Text, LegacyStack, Checkbox, PageActions, Spinner, ResourceList, ResourceItem, Icon, Badge,InlineGrid, Image, Box, Bleed, EmptyState, Button, CalloutCard, Modal, TextContainer, Frame } from '@shopify/polaris';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { BuyButtonMajor, CartMajor, CartDownMajor, ViewMajor, BuyButtonButtonLayoutMajor, SidebarRightMajor } from '@shopify/polaris-icons';
import $ from 'jquery'; 
import { fetchApi } from './helpers/fetchApi';

export class Dashboard extends Component {

    constructor(props) {
        super(props);
        props.setIsLoading(true);

        this.saveChanges = this.saveChanges.bind(this);
        this.discardChanges = this.discardChanges.bind(this);
        this.handleEnabledChange = this.handleEnabledChange.bind(this);
        this.handleLiveModeChange = this.handleLiveModeChange.bind(this);
        this.handleQuickLoadChange = this.handleQuickLoadChange.bind(this);
        this.nextOnboardingStep = this.nextOnboardingStep.bind(this);

        this.state = {
            initState: {}, model: {}, loading: true, onboarding: {}, common: props.common, isEnableAppEmbedBtnClicked: false, isAppEmbedEnabled: true, isProcessing: false, url: window.location.search, showSetupGuideBanner: true, showAppEmbedBanner: false, showDiscountModal: props.discount
        };
    }

    componentDidMount() {
        this.populateData();
        this.getQuickStats();
        this.props.setSaveChanges(this.saveChanges);
        this.props.setDiscardChanges(this.discardChanges);
        this.props.setNextOnboardingStep(this.nextOnboardingStep);
        this.checkAppEmbedStatus();
    }

    discardChanges(){
        debugger;
        this.setState({ model: Object.assign({}, this.state.initState) ,initState: Object.assign({}, this.state.initState) });
    }

    handleChange(fieldName, newValue) {
        window?.shopify?.saveBar?.show("satcb-save-bar");

        this.setState(prevState => {
            let model = Object.assign({}, prevState.model);
            model[fieldName] = newValue;
            const isDirty = JSON.stringify(this.state.initState) !== JSON.stringify(model);
            this.props.setIsDirty(isDirty);
            if(!isDirty){
                window?.shopify?.saveBar?.hide("satcb-save-bar");
            }
            return { model };
        });
    }

    checkAppEmbedStatus = async () => {
        const response = await fetchApi('api/home/AppEmbedStatus');
        const data = await response.json();
        this.setState({ isAppEmbedEnabled: data });
    }

    enableAppEmbed = async () => {
        if (!this.state.isEnableAppEmbedBtnClicked) {
            window.open("https://" + window.shopify.config.shop + "/admin/themes/current/editor?context=apps&&template=product&activateAppId=2d1e1d5d-e947-4201-9a4f-8b73ff50f821%2Fsatcb/app-embed", '_blank');
            this.setState({ isEnableAppEmbedBtnClicked: true })
        } else {
            this.setState({ isProcessing: true });
            const response = await fetchApi('api/home/AppEmbedStatus');
            const data = await response.json();
            this.setState({ isAppEmbedEnabled: data , isProcessing: data ,});
        }
    }

    handleOnboardingChange(skip) {

        if (this.state.onboarding.currentStep === 0) {
            this.setState(prevState => {
                let onboarding = Object.assign({}, prevState.onboarding);
                onboarding.visible = false;
                return { onboarding };
            });
            return;
        }

        if (this.state.onboarding.currentStep === 2 && !skip) {
            window.open(this.state.model.demoUrl, '_blank');
            this.props.doOnboardingStep(this.state.onboarding.currentStep);
        }

        if (this.state.onboarding.currentStep === 23) {
            if (skip) {
                this.completeOnboarding();
                this.props.navigate('support');
            }
            else {
                this.props.doOnboardingStep(this.state.onboarding.currentStep);
            }
        }

        if (this.state.onboarding.currentStep === 3) {
            if (skip) {
                this.props.doOnboardingStep(this.state.onboarding.currentStep);
            }
            else {
                this.props.toggleModalReviewActive();
            }
        }
    }

    handleEnabledChange() {
        this.handleChange('enabled', !this.state.model.enabled);
    }

    handleLiveModeChange() {
        this.handleChange('liveMode', !this.state.model.liveMode);
    }

    handleQuickLoadChange() {
        window.open("https://" + this.props.common.shopName + "/admin/themes/current/editor?context=apps&&template=product&activateAppId=2d1e1d5d-e947-4201-9a4f-8b73ff50f821%2Fsatcb/app-embed", '_blank');
    }

    calcOnboardingProgress() {
        var completedSteps = 1;
        if (this.state.onboarding.step2Done) {
            completedSteps++;
        }
        if (this.state.onboarding.step23Done) {
            completedSteps++;
        }
        if (this.state.onboarding.step3Done) {
            completedSteps++;
        }

        return Math.round(completedSteps / 4 * 100);
    }

    getOnboardingActionText() {
        var txt = 'Close';
        if (this.state.onboarding.currentStep === 2) {
            txt = 'Check it out';
        }
        else if (this.state.onboarding.currentStep === 23) {
            txt = 'All looks good';
        }
        else if (this.state.onboarding.currentStep === 3) {
            txt = 'I\'ll do it!';
        }

        return txt;
    }

    showOnboardingSecondaryAction() {
        return this.state.onboarding.currentStep === 23 || this.state.onboarding.currentStep === 3;
    }

    getOnboardingSecondaryActionText() {
        var txt = '';
        if (this.state.onboarding.currentStep === 23) {
            txt = 'I need help';
        }
        else if (this.state.onboarding.currentStep === 3) {
            txt = 'Skip';
        }

        return txt;
    }

    setOnboardingCurrentStep(step) {
        this.setState(prevState => {
            let onboarding = Object.assign({}, prevState.onboarding);
            onboarding.currentStep = step;
            return { onboarding };
        });
    }

    nextOnboardingStep(prevStep) {
        var nextStep = 0;
        if (prevStep === 2) {
            if (!this.state.onboarding.step23Done) {
                nextStep = 23;
            }
            else if (!this.state.onboarding.step3Done) {
                nextStep = 3;
            }

            this.setState(prevState => {
                let onboarding = Object.assign({}, prevState.onboarding);
                onboarding.step2Done = true;
                onboarding.currentStep = nextStep;
                return { onboarding };
            });
        }
        else if (prevStep === 23) {
            if (!this.state.onboarding.step2Done) {
                nextStep = 2;
            }
            else if (!this.state.onboarding.step3Done) {
                nextStep = 3;
            }

            this.setState(prevState => {
                let onboarding = Object.assign({}, prevState.onboarding);
                onboarding.step23Done = true;
                onboarding.currentStep = nextStep;
                return { onboarding };
            });
        }
        else if (prevStep === 3) {
            if (!this.state.onboarding.step2Done) {
                nextStep = 2;
            }
            else if (!this.state.onboarding.step23Done) {
                nextStep = 23;
            }

            this.setState(prevState => {
                let onboarding = Object.assign({}, prevState.onboarding);
                onboarding.step3Done = true;
                onboarding.currentStep = nextStep;
                return { onboarding };
            });
        }
    }

    showOnboardingStep3() {
        return this.state.onboarding.step2Done && this.state.onboarding.step23Done;
    }

    render() {
        let token = !window.navigate ? `&token=${new URLSearchParams(window.location.search).get("token")}` : "";

        const items = [
            {
                url: '/sticky-atc-bar' + this.state.model.shopQueryString + token,
                name: 'Sticky add to cart bar',
                icon: BuyButtonMajor,
                enabled: this.state.model.stickyAddToCartBarEnabled
            },
            {
                url: '/sticky-cart' + this.state.model.shopQueryString + token,
                name: 'Sticky cart',
                icon: CartMajor,
                enabled: this.state.model.stickyCartEnabled
            },
            {
                url: '/quick-buy-button' + this.state.model.shopQueryString + token,
                name: 'Quick buy button',
                icon: CartDownMajor,
                enabled: this.state.model.quickBuyButtonEnabled
            },
            {
                url: '/quick-view' + this.state.model.shopQueryString + token,
                name: 'Quick view',
                icon: ViewMajor,
                enabled: this.state.model.quickViewEnabled
            },
            {
                url: '/sticky-checkout-bar' + this.state.model.shopQueryString + token,
                name: 'Sticky checkout bar',
                icon: BuyButtonButtonLayoutMajor,
                enabled: this.state.model.stickyCheckoutBarEnabled
            },
            {
                url: '/cart-slider' + this.state.model.shopQueryString + token,
                name: 'Cart slider',
                icon: SidebarRightMajor,
                enabled: this.state.model.cartSliderEnabled
            },
        ];

        const widgets = (
            <ResourceList
                items={items}
                renderItem={(item) => {
                    const { url, name, icon, enabled } = item;

                    return (
                        <ResourceItem
                            url={url}
                            name={name}
                        >
                            <div className="stack-last-right">
                                <LegacyStack>
                                    <LegacyStack.Item>
                                        <Icon source={icon} />
                                    </LegacyStack.Item>
                                    <LegacyStack.Item>
                                        <Text as="span" fontWeight="semibold">{name}</Text>
                                    </LegacyStack.Item>
                                    <LegacyStack.Item fill>
                                        <Badge status={enabled ? 'success' : 'critical'}>{enabled ? 'Enabled' : 'Disabled'}</Badge>
                                    </LegacyStack.Item>
                                </LegacyStack>
                            </div>
                        </ResourceItem>
                    );
                }}
            />
        );
        setInterval(
            function () {
                {
                    let sgb = $("#setup-guide-banner");
                    if ($(sgb).length === 1) {
                        $(sgb).parent().parent().parent().addClass("Polaris-Banner--statusInfo")
                    }
                }
            }
            , 1000)
        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page title={'Hello ' + this.state.model.ownerName + ' 👋'}>
                    <Layout>
                        <Layout.Section>
                            {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed <= 0 && (
                                <Banner
                                    title={`Free plan usage Limit Reached: App Paused Until ${(new Date(this.props.common.freePlanCreditsResetDate)).toLocaleString(undefined, {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    }) }`}
                                    status="critical"
                                    action={{
                                        content: 'Upgrade now', onAction: () => {
                                            const params = new URLSearchParams(this.state.url);
                                            const shop = params.get("shop");
                                            const host = params.get("host");
                                            window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                        }
                                    }}
                                >
                                    <p>
                                        Your store is currently on the Free plan whose limit is reached and the STKTY app is paused until your next 30-day cycle. Upgrade your plan now to avoid disruptions.
                                    </p>
                                </Banner>
                            )}
                            {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed > 0 && (
                                <Banner
                                    title={`Free plan usage: ${this.props.common.freePlanClicksUsed >= 0 ? this.props.common.freePlanClicksUsed : 0} clicks left out of 25`}
                                    status="warning"
                                    action={{
                                        content: 'View plans', onAction: () => {
                                            const params = new URLSearchParams(this.state.url);
                                            const shop = params.get("shop");
                                            const host = params.get("host");
                                            window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                        }
                                    }}
                                >
                                    <p>
                                        Your store is currently on the Free plan. Once 25 clicks are reached, all STKY widgets will be paused until your next 30-day cycle. Upgrade your plan today to avoid disruptions.
                                    </p>
                                </Banner>
                            )}
                        </Layout.Section>
                        <Layout.Section

                        >
                            
                            {
                                typeof(this.props.common.trialDaysLeft) !== "undefined"  && this.props.common.trialDaysLeft > 0 &&
                                <Banner
                                title="Hope you're enjoying your Free Trial!"
                                status="info"
                                action={{content: 'Activate your plan', onAction: () => { 
                                    const params = new URLSearchParams(this.state.url);
                                    const shop = params.get("shop");
                                    const host = params.get("host");
                                    window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                }}}
                                >
                                <p> There's {this.props.common.trialDaysLeft} days left before your free trial expires. Once your trial is over, you'll need to pick a plan to keep enjoying all of Sticky add to cart bar Booster Pro's features. Or, if you're ready you can click the button below to activate it now. Don't worry though, you won't be charged until the free trial is over!</p>
                                </Banner>
                            } 

                            { this.props.discount &&
                                    <Modal
                                        // activator={this.state.showAppEmbedBanner ? <Button onClick={() => { this.setState({ showAppEmbedBanner: false }) }}>Activate App Embed</Button> : null}
                                        open={this.state.showDiscountModal}
                                        onHide={() => { this.setState({ showDiscountModal: false }) }}
                                        title="Success!"
                                        primaryAction={{
                                            content: 'Approve discounted monthly charge',
                                            onAction: () => { 
                                                const params = new URLSearchParams(this.state.url);
                                                const shop = params.get("shop");
                                                const host = params.get("host");
                                                window.open('https://stickyaddtocartbar.azurewebsites.net/Account/ActivatePlan?shop=' + shop + '&host=' + host, '_top');
                                            }
                                        }}
                                    >
                                        <Modal.Section>
                                                    <TextContainer>
                                                    <div className="Polaris-Stack Polaris-Stack--vertical">
                                                        <div className="Polaris-Stack__Item">
                                                            <p>A monthly app subscription discount of {this.props.discount}% off for life has been applied to your account.</p>
                                                        </div>
                                                    </div>
                                                    </TextContainer>
                                        </Modal.Section>
                                    </Modal>

                            }

                        {
                            !this.state.isAppEmbedEnabled &&
                            <Card sectioned>
                                <LegacyStack vertical spacing="loose">
                                    <LegacyStack distribution="equalSpacing" alignment="center">
                                        <div>
                                            <Text variant="headingSm" as="h3">
                                                Theme extension {this.state.isAppEmbedEnabled ? <Badge status="success">Active</Badge> : <Badge status="critical">Inactive</Badge>}
                                            </Text>
                                            <p style={{ marginTop: 8 }}>
                                                Please activate the STKY theme app extension in your store's theme
                                                editor now.
                                            </p>
                                            
                                                <div style={{ marginTop: 16 }}>
                                                    <LegacyStack spacing="tight">
                                                        <Button disabled={this.state.isProcessing} onClick={this.enableAppEmbed}>{this.state.isEnableAppEmbedBtnClicked === false ? 'Enable app embed' : 'Check status'}</Button>
                                                        {/*<Button>Need help?</Button>*/}
                                                    </LegacyStack>
                                                </div>
                                        </div>

                                        <div>
                                            <img
                                                src="/images/STKY-Installation-bg.png"
                                                alt="Theme extension"
                                                width="130"
                                            />
                                        </div>
                                    </LegacyStack>

                                </LegacyStack>
                            </Card>
                        }

                        </Layout.Section>
                        {
                            !this.state.onboarding.visible ? '' :
                                <Layout.Section>
                                    <Card title={'Let\'s get started (' + this.calcOnboardingProgress() + '%)'} sectioned
                                        primaryFooterAction={{ content: this.getOnboardingActionText(), onAction: () => { this.handleOnboardingChange(false) } }}
                                        secondaryFooterActions={this.showOnboardingSecondaryAction() ? [{ content: this.getOnboardingSecondaryActionText(), onAction: () => { this.handleOnboardingChange(true) } }] : null}>
                                        <div className="onboarding-progressbar">
                                            <div className="completed" style={{ width: this.calcOnboardingProgress() + '%' }}></div>
                                        </div>
                                        <ul className="onboarding-steps">
                                            <li><span>1. </span><span className={'step-done'}>App successfully installed</span></li>
                                            <li><span>2. </span><span onClick={() => this.setOnboardingCurrentStep(2)} className={'step-link ' + (this.state.onboarding.step2Done ? 'step-done' : (this.state.onboarding.currentStep === 2 ? 'step-current' : ''))}>App is showing correctly on the storefront</span></li>
                                            <li><span>3. </span><span onClick={() => this.setOnboardingCurrentStep(23)} className={'step-link ' + (this.state.onboarding.step23Done ? 'step-done' : (this.state.onboarding.currentStep === 23 ? 'step-current' : ''))}>Almost there</span></li>
                                            <li style={{ display: this.showOnboardingStep3() ? 'list-item' : 'none' }}><span>4. </span><span onClick={() => this.setOnboardingCurrentStep(3)} className={'step-link ' + (this.state.onboarding.step3Done ? 'step-done' : (this.state.onboarding.currentStep === 3 ? 'step-current' : ''))}>Let us know what you think (optional but takes less than 30 seconds)</span></li>
                                        </ul>
                                    </Card>
                                </Layout.Section>
                        }
                        <Layout.AnnotatedSection
                            title="Quick stats"
                            description="Statistics at a glance."
                        >
                            <LegacyStack distribution="fillEvenly">
                                <Card sectioned title="Total clicks">
                                    {
                                        this.state.quickStats ? <Text variant="heading2xl" as="p">{(this.state.quickStats.totalClicks).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text> :
                                            <div style={{ padding: '0.35rem' }}><Spinner size="small" color="teal" /></div>
                                    }
                                </Card>
                                <Card sectioned title="Total potential revenue">
                                    {
                                        this.state.quickStats ? <Text variant="heading2xl" as="p">{((this.state.quickStats.totalRevenue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')) + ' ' + this.state.quickStats.currency}</Text> :
                                            <div style={{ padding: '0.35rem' }}><Spinner size="small" color="teal" /></div>
                                    }
                                </Card>
                            </LegacyStack>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="App state"
                        //description="You can disable the app to hide it for public and then use the Preview button (step 2.) to see how it would look like if enabled (Don't forget to save the changes first!)"
                        >
                            <div className="setting-toggle-group-card">
                                <Card sectioned>
                                    <SettingToggle action={{
                                        content: this.state.model.enabled ? 'Disable' : 'Enable',
                                        onAction: this.handleEnabledChange
                                    }}
                                        enabled={this.state.model.enabled}
                                    >
                                        <div>The app is currently <Text as="span" fontWeight="semibold">{this.state.model.enabled ? 'enabled' : 'disabled'}</Text>.</div>
                                        <div className="custom-help-text">Master switch.</div>
                                    </SettingToggle>
                                    <SettingToggle action={{
                                        content: this.state.model.liveMode ? 'Disable' : 'Enable',
                                        onAction: this.handleLiveModeChange
                                    }}
                                        enabled={this.state.model.liveMode}
                                    >
                                        <div>Live mode is <Text as="span" fontWeight="semibold">{this.state.model.liveMode ? 'enabled' : 'disabled'}</Text>.</div>
                                        <div className="custom-help-text">{this.state.model.liveMode ? 'The app is visible to all visitors. You can switch it to preview mode anytime.' : 'You as the admin of the store are the only one seeing the app on your storefront. Make sure to have Shopify admin bar visible since that is how app knows you are the admin.'}</div>
                                    </SettingToggle>
                                </Card>
                            </div>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Widgets"
                            description=""
                        >
                            <Card sectioned>
                                <FormLayout>
                                    {widgets}
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="General settings"
                            description=""
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <Checkbox
                                        label="Skip to Checkout when clicked on main (theme's) Add to Cart button"
                                        checked={this.state.model.skipCart}
                                        onChange={(newValue) => this.handleChange('skipCart', newValue)}
                                    />
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Custom seasonal themes"
                            description=""
                        >
                            <Card sectioned>
                                <Card.Section title="Halloween">
                                    <FormLayout>
                                        <Checkbox
                                            label="Show Ghost near Sticky Button"
                                            checked={this.state.model.ghostEnabled}
                                            onChange={(newValue) => this.handleChange('ghostEnabled', newValue)}
                                        />
                                        <Checkbox
                                            label="Show Web and Spider on Sticky Cart"
                                            checked={this.state.model.spiderEnabled}
                                            onChange={(newValue) => this.handleChange('spiderEnabled', newValue)}
                                        />
                                        <Checkbox
                                            label="Show Bats flying around"
                                            checked={this.state.model.batsEnabled}
                                            onChange={(newValue) => this.handleChange('batsEnabled', newValue)}
                                        />
                                        <LegacyStack alignment="center">
                                            <p>Show</p>
                                            <TextField
                                                id="batsXTimes"
                                                type="number"
                                                value={this.state.model.batsXTimes}
                                                onChange={(newValue) => this.handleChange('batsXTimes', newValue)}
                                            />
                                            <p>Bats every</p>
                                            <TextField
                                                id="batsEveryX"
                                                type="number"
                                                value={this.state.model.batsEveryX}
                                                onChange={(newValue) => this.handleChange('batsEveryX', newValue)}
                                            />
                                            <p>seconds</p>
                                        </LegacyStack>
                                    </FormLayout>
                                </Card.Section>

                                <Card.Section title="Winter">
                                    <FormLayout>
                                        <Checkbox
                                            label="Show Santa near Sticky Button"
                                            checked={this.state.model.santaEnabled}
                                            onChange={(newValue) => this.handleChange('santaEnabled', newValue)}
                                        />
                                        <Checkbox
                                            label="Show Santa's hat and Christmas ornament on Sticky Cart"
                                            checked={this.state.model.hatBallEnabled}
                                            onChange={(newValue) => this.handleChange('hatBallEnabled', newValue)}
                                        />
                                        <Checkbox
                                            label="Show falling Snowflakes"
                                            checked={this.state.model.snowEnabled}
                                            onChange={(newValue) => this.handleChange('snowEnabled', newValue)}
                                        />
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Valentine's day">
                                    <FormLayout>
                                        <Checkbox
                                            label="Show Angel near Sticky Button"
                                            checked={this.state.model.angelEnabled}
                                            onChange={(newValue) => this.handleChange('angelEnabled', newValue)}
                                        />
                                        <Checkbox
                                            label="Show Hearts on Sticky Cart"
                                            checked={this.state.model.heartsEnabled}
                                            onChange={(newValue) => this.handleChange('heartsEnabled', newValue)}
                                        />
                                        <Checkbox
                                            label="Show falling Hearts"
                                            checked={this.state.model.showFallingHearts}
                                            onChange={(newValue) => this.handleChange('showFallingHearts', newValue)}
                                        />
                                    </FormLayout>
                                </Card.Section>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.Section>
                        {window.innerWidth < 768 ? 
                            <LegacyStack alignment="center" distribution="center">
                                <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }}
                                    secondaryActions={[{ content: 'Get Support', url: '/support' + this.state.model.shopQueryString + token },
                                    { content: 'Uninstall', id:'btnUninstall' }]}
                                />
                            </LegacyStack> 
                            : 
                                <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }}
                                    secondaryActions={[{ content: 'Get Support', url: '/support' + this.state.model.shopQueryString + token },
                                    { content: 'Uninstall', id:'btnUninstall' }]}
                                />
                            }
                        </Layout.Section>
                    </Layout>
                </Page>
        );
    }

    async populateData() {
        const response1 = fetchApi('api/home/common');


        const response = await fetchApi('api/home/dashboard');
        const data = await response.json();

        const response2 = await response1;
        const data1 = await response2.json();
        this.setState({ common: data1, initState: data, model: data  });

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            this.props.setIsLoading(false);

            var onboarding = {
                visible: false,
                currentStep: 0,
                step2Done: data.onboardingStep2Done,
                step23Done: data.onboardingStep23Done,
                step3Done: data.onboardingStep3Done
            };

            if (!data.onboardingStep2Done) {
                onboarding.visible = true;
                if (onboarding.currentStep === 0) {
                    onboarding.currentStep = 2;
                }
            }

            if (!data.onboardingStep23Done) {
                onboarding.visible = true;
                if (onboarding.currentStep === 0) {
                    onboarding.currentStep = 23;
                }
            }

            if (!data.onboardingStep3Done) {
                onboarding.visible = true;
                if (onboarding.currentStep === 0) {
                    onboarding.currentStep = 3;
                }
            }

            if (data.onboardingStep3Done)
                onboarding.visible = false;

            //Temporary hide Onboading
            onboarding.visible = false;

            this.setState({ initState: data, model: data, loading: false, onboarding: onboarding });
        }
    }

    async saveChanges() {
        this.props.setIsLoading(true);
        const response = await fetchApi('api/home/saveDashboard', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.model) });
        const data = await response.json();
        this.props.setIsLoading(false);

        if (response.ok === true) {
            window?.shopify?.saveBar?.hide("satcb-save-bar");

            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.setState({ initState: Object.assign({}, this.state.model) });
                this.props.setIsDirty(false);
                this.props.setToastActive(true);
            }
        }
    }

    async completeOnboarding() {
        const response = await fetchApi('api/home/completeOnboarding', { method: 'post', headers: { 'Content-Type': 'application/json' } });
        const data = await response.json();

        if (response.ok === true) {
            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
        }
    }

    async getQuickStats() {
        const response = await fetchApi('api/home/analytics');
        const data = await response.json();

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            this.setState({ quickStats: data });
        }
    }

}